import { render } from "./dropdown-actions.html?vue&type=template&id=66f6a1c8&scoped=true&ts=true&external"
import script from "./dropdown-actions.ts?vue&type=script&lang=ts&external"
export * from "./dropdown-actions.ts?vue&type=script&lang=ts&external"

import "./dropdown-actions.scss?vue&type=style&index=0&id=66f6a1c8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f6a1c8"]])

export default __exports__